import LoginVerifyPage from './LoginVerifyPage'

export default LoginVerifyPage
